// Shared chart zoom utilities
// Calculate default visible candles based on granularity (matches Coinbase behavior)

export function getDefaultVisibleCandles(granularityMins: number): number {
  if (granularityMins === 1) return 120;      // 1min: 2 hours
  if (granularityMins === 5) return 144;      // 5min: 12 hours
  if (granularityMins === 15) return 96;      // 15min: 1 day
  if (granularityMins === 60) return 168;     // 1hour: 1 week
  if (granularityMins === 360) return 120;    // 6hour: 1 month
  if (granularityMins === 1440) return 90;    // 1day: 3 months
  return 100; // default fallback
}

